import {
  DialogPanel,
  DialogTitle,
  Dialog as HeadlessUiDialog,
  Transition,
  TransitionChild,
} from "@headlessui/react"
import { XMarkIcon } from "@heroicons/react/24/outline"

interface Props {
  children: React.ReactNode
  onClose: () => void
  open: boolean
}

export default function Dialog({ children, open, onClose }: Props) {
  return (
    <Transition show={open}>
      <HeadlessUiDialog onClose={onClose} open={open}>
        {/* NOTE: The backdrop, rendered as a fixed sibling to the panel container */}
        <TransitionChild
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div aria-hidden="true" className="fixed inset-0 bg-vm-backdrop" />
        </TransitionChild>

        <TransitionChild
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          {/* NOTE: Scrollable dialog, see: https://headlessui.com/react/dialog#scrollable-dialogs */}
          <div className="fixed inset-0 w-screen overflow-y-auto p-4">
            <div className="flex min-h-full items-center justify-center">
              {/* NOTE: The actual dialog panel */}
              <DialogPanel className="w-full max-w-md space-y-4 rounded-card border border-vm-line bg-vm-surface p-6 text-vm-ink shadow-card-hover">
                <DialogTitle as="div" className="text-right">
                  <button
                    className="rounded-full p-1 text-vm-muted transition-colors hover:bg-vm-line hover:text-vm-ink"
                    onClick={onClose}
                    type="button"
                  >
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                </DialogTitle>

                {children}
              </DialogPanel>
            </div>
          </div>
        </TransitionChild>
      </HeadlessUiDialog>
    </Transition>
  )
}
